
import React from "react";
import "./PageStyles.css";

function Home() {
  return (
    <div className="page home-page">
      <h1 className="fade-in">Welcome to ReactSite</h1>
      <p className="fade-in delay-1">
        Empowering developers to build modern, responsive, and dynamic web applications
        using the latest React technologies with routing.
      </p>

      <div className="banner-wrapper fade-in delay-2">
        <img
          src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=tinysrgb&fit=crop&w=900&h=300&q=80"
          alt="Teamwork and Collaboration"
          className="banner"
        />
      </div>
    </div>
  );
}

export default Home;
